
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/updates",
      function () {
        return require("private-next-pages/actuary/updates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/updates"])
      });
    }
  